import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { IMAGES } from "@/config/siteConfig";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import { WhyUs } from "@/components/home/HomeSections";
import { FinalCTA } from "@/components/home/SocialSections";

const VALUES = [
  { title: "Specialist, not generalist", text: "We plan only Kashmir holidays. That focus means better routes, better hotel choices and honest, on-ground advice." },
  { title: "Personal over packaged", text: "No fixed group departures. Every trip is built around your dates, your people and your pace." },
  { title: "Clarity over fine print", text: "Every quote lists exactly what is included and what is not — so you can compare and decide with confidence." },
];

const AboutPage = () => {
  useSEO({
    title: "About Us | Kashmir Holiday Specialists | Book Kashmir",
    description: "Book Kashmir is a specialist Kashmir holiday company offering carefully planned, personalised Kashmir holidays for Indian travellers.",
    path: "/about-us",
  });

  return (
    <main data-testid="about-page">
      <PageHero image={IMAGES.shikara} overline="About Us" title="A Kashmir Specialist You Can Plan With"
        subtitle="Book Kashmir is a specialist Kashmir holiday company offering carefully planned, personalised Kashmir holidays for Indian travellers." />
      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading overline="How We Work" title="Built on Local Knowledge and Personal Service"
            subtitle="We believe a great Kashmir holiday comes from careful planning: the right hotels, a reliable vehicle, sensible pacing and someone to call when you need help." />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-xl bg-white p-7 ring-1 ring-[#0F2F24]/8 shadow-sm" data-testid={`about-value-${v.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <h3 className="font-serif text-lg font-semibold text-[#0F2F24]">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 text-center text-sm text-slate-500">
            Planning a trip? <Link to="/kashmir-tour-packages" className="font-semibold text-[#C28519] hover:underline" data-testid="about-packages-link">Browse our Kashmir packages</Link> or send us an enquiry below.
          </p>
        </div>
      </section>
      <WhyUs />
      <FinalCTA />
    </main>
  );
};

export default AboutPage;
